import { mapGetters } from "vuex";
import router from "../../../router";
import store from "../../../store";
import * as DESTINIES_ACTIONS from "../../../store/destinies/action-types";
import * as DESTINIES_GETTERS from "../../../store/destinies/getter-types";
import handleAppBarItems from "../../../utils/handleAppBarItems";

export default {
  beforeRouteUpdate(to, from, next) {
    if (to.params.slug.length >= 3) {
      store
        .dispatch(DESTINIES_ACTIONS.FETCH_PLACE, to.params.slug)
        .then(() => {
          next();
        })
        .catch(error => {
          next({ name: "404" });
        });
    } else {
      next({ name: "404" });
    }
  },
  data: () => ({
    destinies: [
      {
        image: "/img/destinies/favorites/roma.jpg",
        title: "Roma",
        price: 30,
        link: ""
      },
      {
        image: "/img/destinies/favorites/amsterdam.jpg",
        title: "Amsterdam",
        price: 50,
        link: ""
      },
      {
        image: "/img/destinies/favorites/paris.jpg",
        title: "Paris",
        price: 50,
        link: ""
      }
    ]
  }),
  computed: {
    ...mapGetters({
      selectedDestination: DESTINIES_GETTERS.GET_SELECTED_DESTINY
    }),
    sectionTravelIconsCards() {
      if (!this.selectedDestination) return [];

      const images = ["icon-departure", "destination-map", "live-your-day", "icon-arrival"];
      const cards = [];

      for (let i = 1; i <= 4; i++) {
        cards.push({
          image: `/img/icons/${images[i - 1]}.svg`,
          title: this.selectedDestination[`landing_text_${i}`],
          copy: this.selectedDestination[`landing_description_${i}`]
        });
      }

      return cards;
    }
  },
  created() {
    this.$eventHub.$emit(
      "update-header",
      handleAppBarItems.call(this, router.currentRoute)
    );
  }
};
